
import Button from '../../../components/base/Button';

export default function AppsSection() {
  const features = [
    {
      icon: "ri-mic-line",
      title: "Dynamic Voice Chat Rooms",
      description: "Immersive voice chat spaces supporting role-playing, debates, and creative social interactions with intelligent AI characters.",
      gradient: "from-purple-500 to-blue-500"
    },
    {
      icon: "ri-camera-line", 
      title: "Video Action Recognition",
      description: "Real-time physical action recognition system that transforms real-world gestures into magical in-game effects and quest triggers.",
      gradient: "from-green-500 to-blue-500"
    },
    {
      icon: "ri-sword-line",
      title: "Competitive Combat Mode", 
      description: "Intense real-time PvP combat system with live streaming support, statistical tracking, and strategic respawn mechanisms.",
      gradient: "from-red-500 to-orange-500"
    },
    {
      icon: "ri-robot-line",
      title: "Intelligent AI Characters",
      description: "Learning-capable AI characters that adapt to player behavior and respond within unique virtual worlds.",
      gradient: "from-pink-500 to-purple-500"
    },
    {
      icon: "ri-palette-line",
      title: "Creative World Building",
      description: "Powerful world editing tools that allow users to create unique virtual environments and interactive experiences.",
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      icon: "ri-live-line",
      title: "Social Live Streaming Platform",
      description: "Integrated streaming functionality that lets players share gaming experiences and build community reputation.",
      gradient: "from-orange-500 to-red-500"
    }
  ];

  return (
    <section id="apps" className="px-6 py-20 bg-white/5 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-white text-center mb-8">
          Revolutionary Product Features
        </h2>
        <p className="text-xl text-white/80 text-center mb-16 max-w-3xl mx-auto">
          Experience the future of AI-driven social interaction, immersive creative tools, and competitive gaming.
        </p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition-all group">
              <div className={`w-16 h-16 bg-gradient-to-r ${feature.gradient} rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-white/80 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
